import React, { useEffect, useState } from 'react';
import { Box, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import './custom-products.css';
import { useShop } from '../../../hooks/Shop/useShop';
import UITable from '../../utilities/Table';
import UIInputSearch from '../../utilities/InputSearch';
import { UIButton } from '../../utilities/Button';
import { UiDialogForm } from '../../utilities/DialogForm';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material/styles';

const ShopProductsWarehouseView = () => {
  const theme = useTheme();
  const [query, setQuery] = useState('');
  const [refreshMode, setRefreshMode] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [newValue, setNewValue] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [listBrand, setListBrand] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('null');

  const { onListShopWarehousePaginated, onUpdateShopProductVariantQuantity, onListShopCategories } = useShop();
  const prepareValues = (variants) => {
    return variants?.map((variant) => {
      let quantity = variant?.quantity;
      let color = quantity === 0 ? '#FF3A44' : quantity > 0 && quantity <= 2 ? '#FE922E' : 'inherit';

      return {
        name: variant?.product?.name,
        firstLevel: true,
        subRows: [
          {
            name: variant?.size,
            quantity: (
              <Typography
                color={color}
                sx={{
                  fontWeight: 700
                }}
              >
                {variant?.quantity}
              </Typography>
            ),
            uuid: variant?.uuid,
            price: variant?.price.toFixed(2) + '€',
            actionsEl: (
              <UIButton
                label={'Rifornisci'}
                onClick={() => {
                  setNewValue(variant?.quantity);
                  setSelectedVariant(variant?.uuid);
                  setRefreshMode(true);
                }}
                disableElevation
              />
            )
          }
        ]
      };
    });
  };

  const handleSubmitRefresh = () => {
    let value = Number(newValue);

    if (value >= 0) {
      onUpdateShopProductVariantQuantity({
        variant_uuid: selectedVariant,
        quantity: Number(newValue)
      }).then((res) => {
        toast(res?.response, {
          style: {
            fontSize: '14px',
            backgroundColor: '#00e676',
            color: '#ffffff'
          }
        });
        setRefreshMode(false);
        setForceUpdate(true);
      });
    } else {
      toast('La quantità non può essere vuota o minore di 1', {
        style: {
          fontSize: '14px',
          backgroundColor: 'red',
          color: '#ffffff'
        }
      });
    }
  };

  const handleOnclose = () => {
    setSelectedVariant(null);
    setNewValue(null);
    setRefreshMode(false);
    setForceUpdate(true);
  };

  useEffect(() => {
    setForceUpdate(true);
  }, [query]);

  useEffect(() => {
    onListShopCategories({
      type: 'brand'
    }).then((res) => {
      console.log('res', res);
      console.log('listBrand', listBrand);
      if (res.length > 0) {
        setListBrand(res);
      }
    });
  }, [])

  useEffect(() => {
      setForceUpdate(true);
  }, [selectedBrand])

  return (
    <Box className="variant-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <UiDialogForm
        open={refreshMode}
        onClose={handleOnclose}
        title={'Aggiorna quantità'}
        subtitle={"Inserisci la nuova quantità dell'articolo scelto"}
        onConfirm={handleSubmitRefresh}
        setValue={setNewValue}
        value={newValue}
      />

      <Typography variant={'h4'} align={'center'} textTransform={'uppercase'} fontSize={20} my={2}>
        Magazzino Prodotti
      </Typography>

      <Box my={3} display={'flex'} gap={4} alignItems={'center'}>
        <Box width={'100%'} display={'flex'} gap={1} alignItems={'center'}>
          <Typography variant={'h4'} fontSize={16}>
            Cerca:
          </Typography>
          <UIInputSearch value={query} setValue={setQuery} />
        </Box>
        <Box width={'100%'} gap={1} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant={'h4'} fontSize={16} noWrap minWidth={115}>
            Filtra per brand:
          </Typography>
          <Select
            sx={{ ...theme.typography.customInput }}
            labelId="brand-label"
            id="brand-select"
            value={selectedBrand}
            style={{ width: '100%' }}
            onChange={(event) => {
              setSelectedBrand(event.target.value);
            }}
            input={<OutlinedInput id="categories-input" label="Categorie" />}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250
                }
              }
            }}
            variant={'filled'}
          >
            <MenuItem value={'null'}>Tutte i brand</MenuItem>
            {listBrand.map((brand, index) => (
              <MenuItem key={index} value={brand?.uuid}>
                {brand?.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <WarehouseTable
        prepareValues={prepareValues}
        call={onListShopWarehousePaginated}
        callData={{
          status: 'terminated',
          query,
          brand: selectedBrand === 'null' ? null : selectedBrand
        }}
        headColor={'#FFE1E1'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
      />
      <WarehouseTable
        prepareValues={prepareValues}
        call={onListShopWarehousePaginated}
        callData={{
          status: 'near_terminated',
          query,
          brand: selectedBrand === 'null' ? null : selectedBrand
        }}
        headColor={'#FFD7B2'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
      />
      <WarehouseTable
        prepareValues={prepareValues}
        call={onListShopWarehousePaginated}
        callData={{
          query,
          brand: selectedBrand === 'null' ? null : selectedBrand
        }}
        headColor={'#EAECF0'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
      />
    </Box>
  );
};

const WarehouseTable = ({ prepareValues, headColor, call, callData, forceUpdate, setForceUpdate }) => {
  return (
    <UITable
      columns={[
        {
          name: 'Prodotto',
          value: 'name',
          size: 180
        },
        {
          name: 'Quantità',
          value: 'quantity',
          size: 50
        },
        {
          name: 'Prezzo',
          value: 'price',
          size: 50
        },
        {
          name: '',
          value: 'actionsEl',
          size: 50
        }
      ]}
      infiniteScrollFunction={call}
      callData={callData}
      prepareValues={prepareValues}
      muiTableHeadProps={() => {
        return {
          sx: {
            tr: {
              bgcolor: headColor,
              boxShadow: 'none'
            }
          }
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            bgcolor: row?.original?.firstLevel ? '#EAEAEA' : '#FFF',
            color: '#000',
            fontFamily: 'Oxygen',
            fontWeight: '400',
            fontSize: '15px',
            mt: row?.original?.firstLevel ? '5px' : 0
          }
        };
      }}
      enableRowHoverColor={true}
      enableExpanding={true}
      enableCustomFilters={true}
      stateExpanded={true}
      tableHeight={'calc(100vh - 400px)'}
      forceUpdate={forceUpdate}
      setForceUpdate={setForceUpdate}
      infiniteScrollEndMessage={'Non ci sono altri prodotti da mostrare'}
      muiTablePaperPropsSx={{
        bgcolor: 'transparent',
        boxShadow: 'none'
      }}
    />
  );
};

export default ShopProductsWarehouseView;
